// extracted by mini-css-extract-plugin
export default {"pointsDisplay":"PointsDisplay_pointsDisplay__G2Wb8","visible":"PointsDisplay_visible__SO7xi","plusSign":"PointsDisplay_plusSign__YHAWc","slideIn":"PointsDisplay_slideIn__4Az58"};